/* ==========================================================================
   ATN Homepage V1.0 — Section 02: Hero Banner
   Spec reference: 02_Section.docx §43

   1. Reveal-on-scroll entrance animation (IntersectionObserver).
   2. Optional analytics for the two CTAs and linked statistics.
   ========================================================================== */

(function () {
  'use strict';

  function deviceType() {
    var w = window.innerWidth;
    if (w <= 749) return 'mobile';
    if (w <= 1100) return 'tablet';
    return 'desktop';
  }

  function sectionIdFrom(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
  }

  function send(root, eventName, params) {
    if (root.dataset.analytics !== 'true' || !eventName) return;

    var payload = Object.assign(
      {
        device_type: deviceType(),
        section_id: sectionIdFrom(root),
        current_page: window.location.pathname
      },
      params || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  function reveal(root) {
    if (!root.classList.contains('atn-hero--animate')) return;

    var prefersReduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(root);
  }

  function bindAnalytics(root) {
    if (root.dataset.analytics !== 'true') return;

    root.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-atn-hero-event]');
      if (cta) {
        send(root, cta.dataset.atnHeroEvent, {
          cta_label: (cta.textContent || '').trim(),
          destination_url: cta.getAttribute('href') || '',
          interaction_method: 'click'
        });
        return;
      }

      var stat = event.target.closest('[data-atn-hero-stat]');
      if (stat) {
        send(root, 'homepage_hero_stat_interaction', {
          statistic_name: stat.dataset.atnHeroStat || '',
          destination_url: stat.getAttribute('href') || '',
          interaction_method: 'click'
        });
      }
    });
  }

  function bind(root) {
    if (root.dataset.atnHeroBound === 'true') return;
    root.dataset.atnHeroBound = 'true';
    reveal(root);
    bindAnalytics(root);
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-atn-hero-root]')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();